import { render, staticRenderFns } from "./department-add.vue?vue&type=template&id=35549711&scoped=true&"
import script from "./department-add.vue?vue&type=script&lang=js&"
export * from "./department-add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35549711",
  null
  
)

export default component.exports